import { formatTimeLabel } from "@/lib/booking/time-slots";
import type { Branch } from "@/lib/types/master-data";

export type BranchOperationHours = {
  start: number;
  end: number;
};

export function parseOperationTimeToMinutes(
  time: string | null | undefined,
): number | null {
  if (!time?.trim()) {
    return null;
  }

  const match = time.trim().match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
  if (!match) {
    return null;
  }

  const hours = Number(match[1]);
  const minutes = Number(match[2]);

  if (Number.isNaN(hours) || Number.isNaN(minutes)) {
    return null;
  }

  return hours * 60 + minutes;
}

export function getBranchOperationHours(
  branch: Branch,
): BranchOperationHours | null {
  const start = parseOperationTimeToMinutes(branch.operation_start_time);
  const end = parseOperationTimeToMinutes(branch.operation_end_time);

  if (start === null || end === null || start > end) {
    return null;
  }

  return { start, end };
}

export function isTimeWithinOperationHours(
  minutes: number | undefined,
  hours: BranchOperationHours | null | undefined,
): boolean {
  if (minutes === undefined || !hours) {
    return false;
  }

  return minutes >= hours.start && minutes <= hours.end;
}

export function formatOperationTimeLabel(
  time: string | null | undefined,
): string {
  const minutes = parseOperationTimeToMinutes(time);
  return minutes !== null ? formatTimeLabel(minutes) : "";
}

export function formatOperationHoursRange(
  startTime: string | null | undefined,
  endTime: string | null | undefined,
): string {
  const startLabel = formatOperationTimeLabel(startTime);
  const endLabel = formatOperationTimeLabel(endTime);

  if (!startLabel || !endLabel) {
    return "Contact branch for hours";
  }

  return `${startLabel} - ${endLabel}`;
}
